export enum MlToastVariant {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export interface MlToastProps {
  title: string;
  variant: MlToastVariant;
  onClose?: () => void;
}
